import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

function SwipperHolidays() {

    function updateClassBasedOnScreenSize() {
        const element = document.querySelector(".holidays-page-space");

        if (!element) return;

        if (window.innerWidth >= 1024) {
            element.classList.add("pb-5");

        } else {
            element.classList.remove("pb-5");

        }

        const element_1 = document.querySelector(".holidays-swipper-page");

        if (!element_1) return;

        if (window.innerWidth >= 1024) {
            element_1.classList.add("mb-5");

        } else {
            element_1.classList.remove("mb-5");

        }
    }

    window.addEventListener("load", updateClassBasedOnScreenSize);
    window.addEventListener("resize", updateClassBasedOnScreenSize);

    return (
        <div className="container swiper pt-3 holidays-page-space">
            <div className="holidays-swipper-page popular-state pb-0 pt-0 holidays-container-left">
                <div className="container">
                    <div className="title holidays-left">
                        <h3 className="pb-0"><span>International </span> Destinations</h3>
                    </div>
                </div>
            </div>

            <Swiper
                modules={[Navigation]}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                slidesPerView={5}
                spaceBetween={15}
                loop={true}
                breakpoints={{
                    320: { slidesPerView: 2, spaceBetween: 15 },
                    640: { slidesPerView: 3, spaceBetween: 15 },
                    1024: { slidesPerView: 4, spaceBetween: 15 },
                    1440: { slidesPerView: 5, spaceBetween: 15 },
                }}
            >
                {/* Card 1 - Kazakhstan */}
                <SwiperSlide>
                    <a href="/holidays-list" target="_blank" className="card-link">
                        <div className="card swipper-holidays">
                            <div className="image-content">
                                <div className="card-image">
                                    <img src="assets/img/tours/international/kazakhstan.jpg" alt="Kazakhstan" className="card-img internation-dest-img-sec" />
                                </div>
                            </div>
                            <div className="card-content">
                                <h2 className="properties-title">
                                    <span className="international-country-name">Kazakhstan</span>
                                </h2>
                            </div>
                        </div>
                    </a>
                </SwiperSlide>

                {/* Card 2 - Abu Dhabi */}
                <SwiperSlide>
                    <a href="/holidays-list" target="_blank" className="card-link">
                        <div className="card swipper-holidays">
                            <div className="image-content">
                                <div className="card-image">
                                    <img src="assets/img/tours/international/Abu-Dhabi.jpg" alt="Abu Dhabi" className="card-img internation-dest-img-sec" />
                                </div>
                            </div>
                            <div className="card-content">
                                <h2 className="properties-title">
                                    <span className="international-country-name">Abu Dhabi</span>
                                </h2>
                            </div>
                        </div>
                    </a>
                </SwiperSlide>

                {/* Card 3 - Nepal */}
                <SwiperSlide>
                    <a href="/holidays-list" target="_blank" className="card-link">
                        <div className="card swipper-holidays">
                            <div className="image-content">
                                <div className="card-image">
                                    <img src="assets/img/tours/international/nepal.jpg" alt="Nepal" className="card-img internation-dest-img-sec" />
                                </div>
                            </div>
                            <div className="card-content">
                                <h2 className="properties-title">
                                    <span className="international-country-name">Nepal</span>
                                </h2>
                            </div>
                        </div>
                    </a>
                </SwiperSlide>

                {/* Card 4 - Bhutan */}
                <SwiperSlide>
                    <a href="/holidays-list" target="_blank" className="card-link">
                        <div className="card swipper-holidays">
                            <div className="image-content">
                                <div className="card-image">
                                    <img src="assets/img/tours/international/bhutan.png" alt="Bhutan" className="card-img internation-dest-img-sec" />
                                </div>
                            </div>
                            <div className="card-content">
                                <h2 className="properties-title">
                                    <span className="international-country-name">Bhutan</span>
                                </h2>
                            </div>
                        </div>
                    </a>
                </SwiperSlide>

                {/* Card 5 - Malaysia */}
                <SwiperSlide>
                    <a href="/holidays-list" target="_blank" className="card-link">
                        <div className="card swipper-holidays">
                            <div className="image-content">
                                <div className="card-image">
                                    <img src="assets/img/tours/international/malaysia.png" alt="Malaysia" className="card-img internation-dest-img-sec" />
                                </div>
                            </div>
                            <div className="card-content">
                                <h2 className="properties-title">
                                    <span className="international-country-name">Malaysia</span>
                                </h2>
                            </div>
                        </div>
                    </a>
                </SwiperSlide>

                {/* Card 6 - Sri Lanka */}
                <SwiperSlide>
                    <a href="/holidays-list" target="_blank" className="card-link">
                        <div className="card swipper-holidays">
                            <div className="image-content">
                                <div className="card-image">
                                    <img src="assets/img/tours/international/Srilanka.jpg" alt="Sri Lanka" className="card-img internation-dest-img-sec" />
                                </div>
                            </div>
                            <div className="card-content">
                                <h2 className="properties-title">
                                    <span className="international-country-name">Sri Lanka</span>
                                </h2>
                            </div>
                        </div>
                    </a>
                </SwiperSlide>
            </Swiper>

            <div className="swiper-button-next swiper-navBtn"></div>
            <div className="swiper-button-prev swiper-navBtn"></div>
        </div>
    );
}

export default SwipperHolidays;
